

import { Project } from '@brg/api';
import { isNotEmptyArray, isNotEmptyString, isNotNull } from '@brg/is';

export const Utils = {
    /**
     * Возвращает true, если проект готов к публикации
     * @param project
     */
    projectIsFine(project: Project) {
        return (
            isNotEmptyString(project.title) &&
            isNotNull(project.categoryID) &&
            isNotEmptyArray(project.tagsID) &&
            isNotNull(project.authorId) &&
            isNotEmptyArray(project.coAuthorIds) &&
            isNotEmptyArray(project.titleImages) &&
            isNotNull(project.pointId) &&
            isNotNull(project.longreadId)
        );
    },
    isNumber( ev: any, callback: (val: string) => void ) {
          return (!!Number(ev?.target?.value) || ev?.target?.value === '') && callback(ev.target.value)
    },
    shallowEqual(obj1: any, obj2: any) {
        return Object.keys(obj1).every(key => obj1[key] === obj2[key]);
    }
};


import { Project } from '@brg/api';
import { isNotEmptyArray, isNotEmptyString, isNotNull } from '@brg/is';

export const Utils = {
    /**
     * Возвращает true, если проект готов к публикации
     * @param project
     */
    projectIsFine(project: Project) {
        return (
            isNotEmptyString(project.title) &&
            isNotNull(project.categoryID) &&
            isNotEmptyArray(project.tagsID) &&
            isNotNull(project.authorId) &&
            isNotEmptyArray(project.coAuthorIds) &&
            isNotEmptyArray(project.titleImages) &&
            isNotNull(project.pointId) &&
            isNotNull(project.longreadId)
        );
    },
    isNumber( ev: any, callback: (val: string) => void ) {
          return (!!Number(ev?.target?.value) || ev?.target?.value === '') && callback(ev.target.value)
    },
    shallowEqual(obj1: any, obj2: any) {
        return Object.keys(obj1).every(key => obj1[key] === obj2[key]);
    }
};
